import { PermissionV2 } from './PermissionV2';

export const PermissionV2Value = {
    // [PermissionV2.none]: 0, // No access
    [PermissionV2.read]: 1, // Read only
    [PermissionV2.create]: 2, // Create
    [PermissionV2.update]: 3, // Update
    [PermissionV2.delete]: 4, // Full: including Delete
};
